'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var ButtonLink = require('../../01.atoms/ButtonLink/ButtonLink.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-social-media-bar',
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnButtons = "".concat(CLASSNAME, "__buttons"),
    cnButton = "".concat(CLASSNAME, "__button");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function SocialMediaBar(_ref) {
  var className = _ref.className,
      linkFacebook = _ref.linkFacebook,
      linkYoutube = _ref.linkYoutube,
      title = _ref.title;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnTitle
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: cnButtons
  }, linkFacebook && /*#__PURE__*/React__default.createElement(ButtonLink, {
    target: "_blank",
    type: "tertiary",
    rel: "nofollow",
    iconLeft: "brand-facebook",
    link: linkFacebook,
    className: cnButton,
    iconSize: "sm"
  }), linkYoutube && /*#__PURE__*/React__default.createElement(ButtonLink, {
    target: "_blank",
    type: "tertiary",
    rel: "nofollow",
    iconLeft: "brand-youtube",
    link: linkYoutube,
    className: cnButton,
    iconSize: "sm"
  })));
}
SocialMediaBar.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Link to facebook */
  linkFacebook: PropTypes.string,

  /** Link to youtube */
  linkYoutube: PropTypes.string,

  /** Title of bar */
  title: PropTypes.string.isRequired
};

module.exports = SocialMediaBar;
